import { getStore } from '../store/SharePointItemsViewNavigationLocationStore';
import { mutatorAction } from 'satcheljs';

export const setSharePointItemsViewNavigationPath = mutatorAction(
    'setSharePointItemsViewNavigationPath',
    (groupSmtpAddress: string, path: string): void => {
        const store = getStore();
        groupSmtpAddress = groupSmtpAddress.toLowerCase();
        if (store.has(groupSmtpAddress)) {
            store.get(groupSmtpAddress).currentPath = path;
        } else {
            store.set(groupSmtpAddress, {
                currentPath: path,
                targetPath: undefined,
            });
        }
    }
);

export const setSharePointItemsViewNavigationTargetPath = mutatorAction(
    'setSharePointItemsViewNavigationTargetPath',
    (groupSmtpAddress: string, path: string): void => {
        const store = getStore();
        groupSmtpAddress = groupSmtpAddress.toLowerCase();
        if (store.has(groupSmtpAddress)) {
            store.get(groupSmtpAddress).targetPath = path;
        } else {
            store.set(groupSmtpAddress, {
                currentPath: undefined,
                targetPath: path,
            });
        }
    }
);
